
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4n6tJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0cec8861ce7b67fd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6yXtV = parcelRequire("6yXtV");

var $9wXiX = parcelRequire("9wXiX");
const $0cec8861ce7b67fd$var$GetCBBResources = ()=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [delayed, setDelayed] = (0, $5uXOq.useState)(true);
    // Get ready for the worst code:
    // Adding a timeout to wait for other batch files to get loaded to reduce the batch size.
    (0, $5uXOq.useEffect)(()=>{
        let timer = null;
        if (isReady) timer = setTimeout(()=>setDelayed(false), 3000);
        if (isReady && !delayed) (0, $9wXiX.default)();
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, [
        delayed,
        isReady
    ]);
    return null;
};
var $0cec8861ce7b67fd$export$2e2bcd8739ae039 = $0cec8861ce7b67fd$var$GetCBBResources;

});
parcelRegister("9wXiX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a0cfbe726bffede$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");

var $eNf8a = parcelRequire("eNf8a");

var $4R6GH = parcelRequire("4R6GH");

var $PK2Tm = parcelRequire("PK2Tm");
const $1a0cfbe726bffede$var$sessionStorage = (0, $eNf8a.createSessionStorageProvider)('', false);
const $1a0cfbe726bffede$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
const $1a0cfbe726bffede$var$buildWebResourcesPayload = (resourceArr)=>{
    const payload = {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        r: [],
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        c: [],
        xc: [
            $1a0cfbe726bffede$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    // On the client side we need to avoid fetching any contexts that WRM has already loaded
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.require) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const requireHandlerWrapper = window.require('wrm/require-handler-wrapper');
        const requireHandler = requireHandlerWrapper?.getRequireHandler();
        if (requireHandler) {
            const prefetchedResources = requireHandler?.requireHandlerV2?._cache.getExclusionLists() // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .context?.filter((item)=>item !== $1a0cfbe726bffede$var$JIRA_HERITAGE_CRITICAL_BATCH);
            payload.xc = payload.xc.concat(prefetchedResources);
        }
    }
    resourceArr.forEach((resource)=>{
        if (resource.indexOf('wrc!') !== -1) payload.c.push(resource.slice(4));
        else if (resource.indexOf('wr!') !== -1) payload.r.push(resource.slice(3));
        else payload.r.push(resource);
    });
    return payload;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1a0cfbe726bffede$var$setResourceUrl = (resourceUrl)=>{
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) $1a0cfbe726bffede$var$sessionStorage.set('classicBatchUrl', JSON.stringify(resourceUrl));
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.sessionStorage.setItem('classicBatchUrl', JSON.stringify(resourceUrl));
};
const $1a0cfbe726bffede$var$removeResourceUrl = ()=>{
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) $1a0cfbe726bffede$var$sessionStorage.remove('classicBatchUrl');
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.sessionStorage.removeItem('classicBatchUrl');
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1a0cfbe726bffede$var$addPrefetchLinkstoDOM = (batchUrl)=>{
    // @ts-expect-error - TS7006 - Parameter 'resource' implicitly has an 'any' type.
    batchUrl.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType } = resource;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const linkTag = document.createElement('link');
        linkTag.href = url;
        if (resourceType === 'CSS') // excluding CSS because CSS prefetching causes the board to load
        // in a funny way. No workaround known and decided to exclude as
        // impact will be low.
        return;
        linkTag.rel = 'prefetch';
        linkTag.as = 'script';
        // inject links in the head of the document
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head.appendChild(linkTag);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1a0cfbe726bffede$export$2e2bcd8739ae039 = async ()=>{
    const contexts = (0, $PK2Tm.getRequiredResourceList)('rapidboard-board');
    const payload = $1a0cfbe726bffede$var$buildWebResourcesPayload(contexts);
    try {
        const res = await (0, $7f4tk.default)('/rest/webResources/1.0/resources?operation=FetchWRMData', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
        // store the resource Url to avoid resource endpoint call when transitioning to rapidboards
        $1a0cfbe726bffede$var$setResourceUrl(res);
        // Add prefetch links to the DOM
        $1a0cfbe726bffede$var$addPrefetchLinkstoDOM(res);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // If prefetch fails, don't throw error on other's page. Instead log it and continue.
        $1a0cfbe726bffede$var$removeResourceUrl();
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa.view.routes.classic-projects.work-all-data.getData', 'An error was thrown while prefetching work all data', error);
    }
};

});
parcelRegister("PK2Tm", function(module, exports) {

$parcel$export(module.exports, "buildAllDataQueryParams", () => $df00ee708c57537c$export$487708debaea6de3);
$parcel$export(module.exports, "getInlineScriptData", () => $df00ee708c57537c$export$7bd4b867b9305f97);
$parcel$export(module.exports, "getRapidViewConfigFromRouteName", () => $df00ee708c57537c$export$62c86c4062215346);
$parcel$export(module.exports, "getRequiredResourceList", () => $df00ee708c57537c$export$7bff98a3d459b1b8);
$parcel$export(module.exports, "getConfigFromRouterContext", () => $df00ee708c57537c$export$1705c550e5b835bf);

var $4R6GH = parcelRequire("4R6GH");

var $1odlY = parcelRequire("1odlY");

var $9hNId = parcelRequire("9hNId");
const $df00ee708c57537c$export$487708debaea6de3 = (query, match)=>{
    const { rapidView: rapidView, quickFilter: quickFilter, projectKey: queryProjectKey, etag: etag } = query;
    const boardId = match.params.boardId || rapidView;
    const projectKey = match.params.projectKey || queryProjectKey;
    let activeQuickFilters = '';
    if (quickFilter) activeQuickFilters = Array.isArray(quickFilter) ? quickFilter.reduce((prevFilter, nextFilter)=>`${prevFilter}&activeQuickFilters=${nextFilter}`, activeQuickFilters) : `&activeQuickFilters=${quickFilter}`;
    const etagParam = etag ? `&etag=${etag}` : '';
    const projectKeyParam = projectKey ? `&selectedProjectKey=${projectKey}` : '';
    const { GH: GH } = window;
    const forceConsistency = '&forceConsistency=true';
    GH?.RapidBoard?.State?.setRapidViewIdForEventuallyConsistentBoard(undefined);
    return `rapidViewId=${boardId}${projectKeyParam}${activeQuickFilters}${etagParam}${forceConsistency}`;
};
const $df00ee708c57537c$var$cleanUpInlineScript = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window[dataName];
};
const $df00ee708c57537c$export$7bd4b867b9305f97 = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const req = window[dataName];
    if (!req) return null;
    if (req.readyState === req.DONE && req.status !== 200) {
        $df00ee708c57537c$var$cleanUpInlineScript(dataName);
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((r)=>{
        if (req.readyState === req.DONE && req.status === 200) {
            $df00ee708c57537c$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        } else req.addEventListener('load', ()=>{
            $df00ee708c57537c$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        });
    });
};
const $df00ee708c57537c$export$62c86c4062215346 = (routeName)=>{
    for (const routeConfig of Object.values((0, $9hNId.RAPID_VIEW_ROUTE_CONFIG))){
        if (routeConfig.routes?.includes(routeName)) return routeConfig;
    }
    return (0, $9hNId.RAPID_VIEW_ROUTE_CONFIG).DEFAULT;
};
const $df00ee708c57537c$export$7bff98a3d459b1b8 = (view)=>{
    let rapidboardResources = (0, $1odlY.WRM_RESOURCES_ARRAY);
    if ((0, $4R6GH.fg)('reports-overview-page-migration')) {
        if (view) {
            const routeConfig = $df00ee708c57537c$export$62c86c4062215346(view);
            return [
                ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
                ...routeConfig.resources
            ];
        }
        return [
            ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
            ...(0, $9hNId.RAPID_VIEW_ROUTE_CONFIG).DEFAULT.resources
        ];
    }
    // eslint-disable-next-line default-case
    switch(view){
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-user-board':
        case 'servicedesk-boards':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-practice-custom-board':
            rapidboardResources = (0, $1odlY.WRM_BOARD_RESOURCES_FHD_ARRAY);
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
        case 'rapidboard-backlog-embed':
            rapidboardResources = (0, $1odlY.WRM_BACKLOG_RESOURCES_FHD_ARRAY);
            break;
    }
    return [
        ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
        ...rapidboardResources
    ];
};
function $df00ee708c57537c$export$1705c550e5b835bf(routerContext) {
    return routerContext.match?.params.config || routerContext.query?.config || '';
}

});
parcelRegister("1odlY", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $fa7f7a1583a8dcf1$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $fa7f7a1583a8dcf1$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", () => $fa7f7a1583a8dcf1$export$395f77888d07f2e0);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $fa7f7a1583a8dcf1$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $fa7f7a1583a8dcf1$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$1f599d2eef0a7281);
const $fa7f7a1583a8dcf1$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $fa7f7a1583a8dcf1$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $fa7f7a1583a8dcf1$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
const $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $fa7f7a1583a8dcf1$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $fa7f7a1583a8dcf1$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $fa7f7a1583a8dcf1$export$ccd0929652c235de = [];
const $fa7f7a1583a8dcf1$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $fa7f7a1583a8dcf1$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("9hNId", function(module, exports) {

$parcel$export(module.exports, "RAPID_VIEW_ROUTE_CONFIG", () => $f34cebd5a04e9077$export$99d0df2f58f37dfe);

var $1odlY = parcelRequire("1odlY");
const $f34cebd5a04e9077$export$99d0df2f58f37dfe = {
    BOARD: {
        routes: [
            'rapidboard-board',
            'rapidboard-board-embed',
            'rapidboard-user-board',
            'servicedesk-boards',
            'servicedesk-queues-custom-board',
            'servicedesk-queues-practice-custom-board'
        ],
        resources: (0, $1odlY.WRM_BOARD_RESOURCES_FHD_ARRAY),
        stateKey: 'board-state'
    },
    BACKLOG: {
        routes: [
            'rapidboard-backlog',
            'rapidboard-user-backlog',
            'rapidboard-backlog-embed'
        ],
        resources: (0, $1odlY.WRM_BACKLOG_RESOURCES_FHD_ARRAY),
        stateKey: 'backlog-state'
    },
    DEFAULT: {
        resources: (0, $1odlY.WRM_RESOURCES_ARRAY),
        stateKey: 'report-state'
    }
};

});





//# sourceMappingURL=async-classic-resources.3768a22f.js.map
